import Pia from '../pia/type';

export const fundFullIntKeys: (keyof Pia.FundsRows)[] = [
  'reported_building_expenses',
  'reported_capital_distribution',
  'reported_units_outstanding',
  'reported_estimated_liquidation_taxes',
  'reported_maintenance_and_repairs_expenses',
  'reported_profit_and_capital_taxes',
  'reported_property_tax',
  'reported_realised_capital_gains_and_losses',
  'reported_realised_income',
  'reported_rental_income',
  'reported_retained_earnings',
  'reported_revenue_from_postal_and_bank_accounts',
  'reported_short_term_interest_bearing_mortgages',
  'reported_short_term_liabilities',
  'reported_taxes',
  'reported_total_cash',
  'reported_total_expenses',
  'reported_total_income',
  'reported_total_interest',
  'reported_total_liabilities',
  'reported_total_properties',
  'reported_total_revenue',
  'reported_unrealised_capital_gains_and_losses',
  'reported_valuation_and_auditing_expenses',
  'reported_valuation_expenses',

  'reported_market_maker_fees',
  'reported_absolute_custodian_bank_fees',
  'reported_absolute_management_fees',
  'reported_administration_of_buildings',
  'reported_auditing_expenses',

  'computed_current_liabilities',

  'computed_operating_profit',

  'reported_dividend_distribution',

  'reported_ebit',
  'reported_invested_capital',
  'reported_long_term_interest_bearing_mortgages',
  'reported_long_term_liabilities',

  'reported_mortgage_interest',
  'reported_negative_interest',
  'reported_net_assets_at_beginning_of_the_financial_year',
  'reported_net_assets_before_estimated_liquidation_taxes',
  'reported_net_income',
  'reported_net_income_available_for_distribution',
  'reported_nopat',
  'reported_ordinary_income_carried_forward_from_previous_financial_year',
  'reported_other_assets',
  'reported_other_expenses',
  'reported_other_interest',
  'reported_other_long_term_liabilities',
  'reported_other_revenue',
  'reported_other_short_term_liabilities',

  'reported_market_cap',
  'reported_tga_after_distribution',
  'reported_tga_before_distribution',
  'reported_tna_after_distribution',
  'reported_tna_before_distribution',
  'computed_total_agio_at_year_end',

  'computed_tga_compounded',
  'computed_tna_compounded',
  'computed_total_current_agio_after_distribution',
  'computed_total_current_agio_compounded',

  'market_market_cap',

  'reported_total_rental_space',
  'reported_commercial_rental_space',
  'reported_residential_rental_space',
  'reported_mixed_rental_space',
  'reported_plots_rental_space',
  'reported_other_rental_space',

  'reported_capital_employed',
  'computed_total_net_rent',
  'estimated_total_income',

  'reported_building_groups_nb',
  'computed_buildings_nb',
  'computed_dwellings_nb',
  'computed_lots_nb',

  'reported_unrealised_gains_and_losses_including_var_est_liq_tax',
  'market_five_days_avg_volume',
  'market_one_month_avg_volume',
  'market_one_year_avg_volume',
  'market_six_months_avg_volume',
  'market_three_months_avg_volume',
  'market_volume',
  'estimated_total_net_rent',
  'estimated_total_market_value',
  'reported_co2',
  'reported_total_energy',
  'reported_heated_area',
];

export default fundFullIntKeys;
